import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Nav from "./components/landing/Nav";
import Hero from "./components/landing/Hero";
import PressStrip from "./components/landing/PressStrip";
import MarqueeStrip from "./components/landing/MarqueeStrip";
import Capabilities from "./components/landing/Capabilities";
import Split from "./components/landing/Split";
import Proof from "./components/landing/Proof";
import Founder from "./components/landing/Founder";
import Press from "./components/landing/Press";
import Process from "./components/landing/Process";
import FinalCta from "./components/landing/FinalCta";
import Footer from "./components/landing/Footer";
import StickyWhatsApp from "./components/landing/StickyWhatsApp";
import ChatWidget from "./components/landing/ChatWidget";

function App() {
    return (
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
            <div className="App font-sans" data-testid="chatproz-site">
                <Nav />
                <main>
                    <Hero />
                    <PressStrip />
                    <MarqueeStrip />
                    <Capabilities />
                    <Split />
                    <Proof />
                    <Founder />
                    <Press />
                    <Process />
                    <FinalCta />
                </main>
                <Footer />
                <StickyWhatsApp />
                <ChatWidget />
                <Toaster position="top-center" richColors />
            </div>
        </ReactLenis>
    );
}

export default App;
